<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.teams.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['project_teams'], ['read'])"
                        :importable="true"
                        title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowClickTeamMembers="onUserRow"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        >
                    </data-table>

                    <button type="button" class="btn btn-secondary mt-2 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_teams'], ['create'])">
                        <i class="fa fa-plus-circle"></i> {{$t('general.teams.create_button')}}
                    </button>

                    <span v-if="this.$store.getters.hasPermission(['project_teams'], ['create', 'update'])">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3" @click="$refs.importExcel.value = ''">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.teams.import_button') }}</span>
                            <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                        </label>
                        <label v-else class="btn btn-primary mt-3 disabled">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>

                <div class="row" v-if="getData.rowData.length > 0">
                    <div class="col-sm-12">
                        <i class="fa fa-2x fa-users text-info"></i> - {{$t('general.buttons.team_members')}}
                    </div>
                </div>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" id="saveModal" :title="actionTitle" size="md" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_teams'], ['update']))">
            <div class="row">
                <div class="col-lg-4">
                    <label>{{ $t('table.name') }}</label>
                </div>
                <div class="col-lg-8">
                    <input type="text" maxlength="50" class="form-control" v-model="model.name">
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import Multiselect from 'vue-multiselect';
import _ from 'lodash';

Vue.component(Multiselect);
export default {
    name: 'teams',
    components: {
        Multiselect,
        DataTable,
        ConfirmDialog,
        notificationIcons,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.teams.title'),
                    active: true
                }
            ],
            tableName: 'team',
            tableNameTranslated: Vue.i18n.translate('general.teams.title_modal'),
            row: null,
            tableLoaded: false,
            perPage: 0,
            pageCount: 1,
            rowsCount: 0,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            isLoading: false,
            selectedProject: {},
            currentProjects: [],
            getData: {
                rowData: []
            },
            model: {
                id: null,
                name: null,
                //company_id: null,
            },

            selectedCompanies: [],
            currentCompany: [],
            isLoadingCompany: false,
            searchTextCompany: Vue.i18n.translate('general.search.type_to_search_company'),
            currentCompanyNoSelect: false,

            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '130px',
                    field: '',
                    showDeleteButton: true,
                    showEditButton: true,
                    showTeamMembersButton: true
                },
                {
                    label: Vue.i18n.translate('table.company'),
                    field: 'company_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.name'),
                    field: 'name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.leader'),
                    field: 'team_leader.fullname',
                    numeric: false,
                    html: false,
                },
            ]
        }
    },
    mounted() {
        this.onLoadTable();

        http.route('company?project_id='+ this.$route.params.id ).get().then(response => {
            if (response.data != false) {
                this.currentCompanyNoSelect = true;
                this.currentCompany = response.data;
            }
        });
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            http.route(this.tableName + '?project_id='+this.$route.params.id+'&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get().then(response => {
                if (!response.isError) {
                    this.perPage         = response.pagination.limit;
                    this.rowsCount       = response.pagination.totalEntries;
                    this.currentPage     = response.pagination.currentPage;
                    this.pageCount       = response.pagination.totalPages;
                    this.getData.rowData = response.data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        clearSearches () {
            this.selectedProject = {};
            this.currentProjects = [];
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated
            this.row = null;
            this.model.name = null;
            this.selectedProject = null;
            this.clearSearches();
            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.model.name = this.row.name;
            this.$refs.saveModal.show();
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        onUserRow(row, index) {
            this.$router.push({name: 'team_members', params: {id: row.project_id, idm: row.id}});
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                project_id: this.$route.params.id,
                name: this.model.name,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row) {
                http.route(this.tableName + '/' + this.row.id).patch(put_data, true).then(response => {
                    if (response.isError) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.onLoadTable();
                        this.$refs.saveModal.hide();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
            } else {
                http.route(this.tableName).post(put_data, true).then(response => {
                    if (response.isError) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.onLoadTable();
                        this.$refs.saveModal.hide();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                    }
                });
            }
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (response.isError == false) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        onExportButton() {
            http.route(this.tableName + '?project_id=' + this.$route.params.id).exportExcel({
                export: 1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'teams.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            formData.append('project_id', this.$route.params.id);

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            http.route(this.tableName+'/import?project_id='+this.$route.params.id).importExcel(formData)
            .then(response => {
                if (response.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.imported'));
                }
            });
        },
    }
}
</script>

<style scoped>

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/pages/project/teams/teams.vue